import loadable from '@loadable/component';

export const LazyShippingPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/shippingpolicy" */
      '.'
    ),
);
